import React, { useMemo } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { Chart } from "./Chart";

export default function RadarChart({ scores, loading, hasData = true }) {
  const scoreArray = useMemo(
    () => [
      scores.physical,
      scores.emotional,
      scores.acceptance,
      scores.relationships,
      scores.loving_kindness,
      scores.intellectual,
    ],
    [scores]
  );

  const avgScore = useMemo(() => {
    const vals = scoreArray.filter((v) => typeof v === "number");
    if (!vals.length) return 0;
    return vals.reduce((a, b) => a + b, 0) / vals.length;
  }, [scoreArray]);

  return (
    <Box
      sx={{
        borderRadius: 2,
        bgcolor: "background.paper",
        p: 2.5,
        boxShadow: 1,
        marginBlock: 2
      }}
    >
      <Typography variant="h6" fontWeight={600} mb={0.5}>
        Average PEARLI Assessment Scores
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Participants average assessment scores across PEARLI domains
      </Typography>

      {loading ? (
        <Skeleton variant="rectangular" height={260} />
      ) : !hasData ? (
        <Box
          sx={{
            height: 260,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
            fontSize: "0.9rem",
            opacity: 0.8,
          }}
        >
          No assessment data available for the selected filters.
        </Box>
      ) : (
        <Box sx={{ minHeight: 260, display: "flex", justifyContent: "center" }}>
          <Chart scores={scoreArray} />
        </Box>
      )}

      <Box mt={2} textAlign="center">
        <Typography variant="subtitle2">
          Average Score:{" "}
          {hasData && avgScore ? `${avgScore.toFixed(1)}/5.0` : "No data"}
        </Typography>
      </Box>
    </Box>
  );
}
